import React from 'react';
import {
  Container, // Reusing your main container style
  SectionTitle,
  ExceptionButtonRow,
  LateArrivalButton,
  AbsentButton
} from './styles';

interface LogExceptionProps {
  isAbsent: boolean;
  isLateArrival: boolean;
}

const LogException: React.FC<LogExceptionProps> = ({ isAbsent, isLateArrival }) => {
  return (
    <Container>
      {(isAbsent || isLateArrival) &&
        <>
          <SectionTitle>Log Exception</SectionTitle>

          <ExceptionButtonRow>
            {isLateArrival &&
              <LateArrivalButton
                variant="contained"
              >
                Late Arrival
              </LateArrivalButton>
            }

            {isAbsent &&
              <AbsentButton
                variant="contained"
              >
                Absent
              </AbsentButton>
            }
          </ExceptionButtonRow>
        </>
      }

    </Container>
  );
};

export default LogException;